"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function MinusInCircleIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M19.892,4.108A11.161,11.161,0,0,0,4.107,19.892a11.162,11.162,0,0,0,15.785,0h0a11.162,11.162,0,0,0,0-15.784ZM18.69,18.69h0a9.457,9.457,0,1,1,0-13.38A9.392,9.392,0,0,1,18.689,18.69Z" }),
        react_1.default.createElement("rect", { x: "6.351", y: "11.15", width: "11.299", height: "1.699" })));
}
exports.default = MinusInCircleIcon;
